import React, { useState } from 'react';
import { contactAPI } from '../services';

const ACCENT = '#1a5fff';

const inputStyle = {
  width: '100%', padding: '12px 14px',
  fontFamily: '"DM Sans",system-ui,sans-serif', fontSize: 14,
  background: '#f8f9fb', border: '1.5px solid #e4e7ed',
  borderRadius: 8, color: '#0d1117',
  outline: 'none', transition: 'border-color .15s', resize: 'none'
};

const labelStyle = {
  display: 'block', fontSize: 11, fontWeight: 700, color: '#717888',
  marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.4px'
};

const EMPLOYEE_RANGES = [
  ['1-10', '1–10 employees'],
  ['11-50', '11–50 employees'],
  ['51-200', '51–200 employees'],
  ['201-500', '201–500 employees'],
  ['500+', '500+ employees'],
];

const focusInput = e => { e.target.style.borderColor = ACCENT; e.target.style.background = '#fff'; };
const blurInput = e => { e.target.style.borderColor = '#e4e7ed'; e.target.style.background = '#f8f9fb'; };

const ContactForm = ({ title = 'Book a free Demo', subtitle = "We'll call you back within 2 hours.", style = {} }) => {
  const [form, setForm] = useState({ name: '', phone: '', company: '', employees: '' });
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const digits = form.phone.replace(/\D/g, '');
    if (digits.length < 10 || digits.length > 13) {
      setStatus({ type: 'error', msg: 'Please enter a valid phone number (10 digits, with country code if outside India).' });
      return;
    }
    setSubmitting(true);
    setStatus(null);
    try {
      const name = form.name.trim();
      const company = form.company.trim();
      const payload = {
        name,
        phone: form.phone.trim(),
        company,
        employees: form.employees,
        subject: 'demo',
        message: `Demo request from ${name}${company ? ' at ' + company : ''}. Team size: ${form.employees || 'Not specified'}.`,
      };
      const res = await contactAPI.submitContactForm(payload);
      if (res.status === 'success') {
        setStatus({ type: 'success', msg: "Thanks! We'll call you back within 2 hours to confirm your demo slot." });
        setForm({ name: '', phone: '', company: '', employees: '' });
      } else { setStatus({ type: 'error', msg: res.message || 'Failed to submit. Please try again.' }); }
    } catch {
      setStatus({ type: 'error', msg: 'An error occurred. Please WhatsApp us instead.' });
    } finally { setSubmitting(false); }
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #e4e7ed', borderRadius: 20, padding: 36, boxShadow: '0 4px 24px rgba(13,17,23,.08)', ...style }}>
      {title && <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: subtitle ? 6 : 24, color: '#0d1117' }}>{title}</h3>}
      {subtitle && <p style={{ fontSize: 13, color: '#717888', marginBottom: 24 }}>{subtitle}</p>}

      {status && (
        <div style={{ marginBottom: 20, padding: '12px 16px', borderRadius: 12, background: status.type === 'success' ? '#dcfce7' : '#fee2e2', color: status.type === 'success' ? '#15803d' : '#dc2626', fontSize: 14 }}>
          {status.msg}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Your Name *</label>
          <input name="name" value={form.name} onChange={handleChange} required placeholder="Priya Sharma" style={inputStyle}
            onFocus={focusInput} onBlur={blurInput} />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>WhatsApp / Phone *</label>
          <input name="phone" type="tel" inputMode="tel" autoComplete="tel" value={form.phone} onChange={handleChange} required
            pattern="\+?[0-9\s\-]{10,18}" title="Enter a phone number using digits (e.g. +91 95426 43011)" placeholder="+91 95426 43011" style={inputStyle}
            onFocus={focusInput} onBlur={blurInput} />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Company Name *</label>
          <input name="company" value={form.company} onChange={handleChange} required placeholder="Acme Corp" style={inputStyle}
            onFocus={focusInput} onBlur={blurInput} />
        </div>

        <div style={{ marginBottom: 22 }}>
          <label style={labelStyle}>Number of employees</label>
          <select name="employees" value={form.employees} onChange={handleChange} style={{ ...inputStyle, cursor: 'pointer' }}
            onFocus={focusInput} onBlur={blurInput}>
            <option value="">Select team size</option>
            {EMPLOYEE_RANGES.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
        </div>

        <button type="submit" disabled={submitting}
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: 14, borderRadius: 10, background: submitting ? '#93b4ff' : ACCENT, color: '#fff', fontSize: 15, fontWeight: 700, border: 'none', cursor: submitting ? 'not-allowed' : 'pointer', transition: 'background .15s' }}>
          {submitting ? 'Submitting…' : <>Book my free demo <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg></>}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
